<template>
  <div>
    Redirecting
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted: function() {
    const email = this.$route.query.email
    if (email) {
      this.$auth.loginWithRedirect({
        screen_hint: 'signup',
        login_hint: email
      })
    } else {
      this.$router.push('/login')
    }
  }
}
</script>
